import { CSSProperties, cx } from '@linaria/core';
import { memo, ReactEventHandler, Ref } from 'react';
import { aspectRatio } from '../../../utilities/dimensions';
import "./PosterImage.linaria.module.css!=!./PosterImage?./PosterImage.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNLy+Mz04yzyurqq7SzcxLSa2wMrSu5dIDSaUaxRumZJsWZiZWZ6RmpmeUWJUlFmno6kI4mjBlZZXxRVWlJUVG1eWZKSUZUEVgNlyNYXm8YaGpoaF5anVicUFqcoluUWJJZj5ULbIQSAsAw1kiv5kAAAA="
type PosterImageProps = {
  onError?: ReactEventHandler<HTMLImageElement>;
  onLoad?: ReactEventHandler<HTMLImageElement>;
  ref?: Ref<HTMLImageElement>;
  setDimensions?: boolean;
  testId?: string;
  height: number;
  width: number;
  src: string;
};
const stylesRoot = "atm_wq_kb7nvz atm_e2_1dk5qia atm_vy_rzutr2";
const stylesAspectRatio = "atm_1w_1q5117e";
const PosterImage = memo((props: PosterImageProps) => {
  const {
    setDimensions,
    width,
    height,
    src,
    testId,
    ref,
    onLoad,
    onError
  } = props;
  const {
    height: imageHeight,
    width: imageWidth
  } = aspectRatio({
    height,
    width
  });
  const setHeight = setDimensions && imageHeight > 0;
  const setWidth = setDimensions && imageWidth > 0;
  const cssHeight = setHeight ? `${imageHeight}px` : '100%';
  const cssWidth = setWidth ? `${imageWidth}px` : '100%';
  return <img style={{
    '--height': setHeight ? imageHeight + 'px' : cssHeight,
    '--width': setWidth ? imageWidth + 'px' : cssWidth,
    '--aspect-ratio': `${imageWidth}/${imageHeight}`
  } as CSSProperties} className={cx('mfc-image-asset', stylesRoot, setHeight && setWidth && stylesAspectRatio)} data-testid={testId} onError={onError} onLoad={onLoad} ref={ref} src={src} />;
});
export default PosterImage;